<template>
  <div style="display: inline;">
<!--    <el-tabs v-model="tabPosition" style="margin-left: 22px;">
      <el-tab-pane :label="$t('siyin')" name="1"> </el-tab-pane>
      <el-tab-pane :label="$t('zuzhuang')" name="2"> </el-tab-pane>
    </el-tabs>
    <div :style="{ height: contentHeight }">
      <div v-show="tabPosition == '1'" style="height: 100%;">
        <screen_printing ref="screenPrintingTable"></screen_printing>
      </div>
      <div v-show="tabPosition == '2'" style="height: 100%;">
        <assemble ref="assembleTable"></assemble>
      </div>
    </div>-->
    <div class="dialog-scroller">
      <yi_tabs :tabs="[{ title: 'siyin', cache: true }, { title: 'zuzhuang', cache: true }]">
        <template #siyin>
          <screen_printing ref="screenPrintingTable"></screen_printing>
        </template>
        <template #zuzhuang>
          <assemble ref="assembleTable"></assemble>
        </template>
      </yi_tabs>
    </div>
  </div>
</template>

<script type="text/javascript">
import screen_printing from '@@/pages/web/customize/weier/screen_printing_management/production_plan/screen_printing';
import assemble from '@@/pages/web/customize/weier/screen_printing_management/production_plan/assemble';
export default {
  name: 'web_customize_weier_screen_printing_management_production_plan_list',
  components: {
    screen_printing,
    assemble
  },
  data() {
    return {
      tabPosition: '1',
      contentHeight: 0
    };
  },
  mounted() {
    // 页面加载完成后自动加载当前标签页的表格数据
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  created() {},
  methods: {
    resize() {
      this.$nextTick(() => {
        console.log('resize', window.innerHeight);
        this.contentHeight = window.innerHeight - 54 + 'px';
      });
    }
  }
};
</script>
